'use strict';
(function () {

    var EnterFrame = require('../util/enterframe'),
        EventDispatcher = require('../util/eventdispatcher'),
        THREE = require('three'),
        _ = require('lodash');

    require('./CSS3DRenderer');

    var _root = new THREE.Object3D(),
        _enterframe = new EnterFrame();

    var _onResize = function () {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.render();
    };

    var Scene = function (element) {
        _.bindAll(this);
        EventDispatcher.call(this);
        _enterframe.addEventListener(EnterFrame.RENDER, this.render);
        this.el = element;
    };

    Scene.prototype = _.extend({

        getRootObject: function () {
            return this.scene;
        },
        
        add:function(obj){
            this.scene.add(obj);
        },

        init: function () {
            this.camera = new THREE.PerspectiveCamera(30, window.innerWidth / window.innerHeight, 1, 10000);
            this.camera.position.z = 1946;

            
            this.scene = new THREE.Scene();
            this.renderer = new THREE.CSS3DRenderer();
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            this.renderer.domElement.style.position = 'absolute';
            this.el.appendChild(this.renderer.domElement);
            //            this.scene.add(_root);
            _.bind(_onResize, this)();
            this.render();
            window.addEventListener('resize', _.bind(_onResize, this), false);
        },
        start: function () {
            _enterframe.start();
        },
        stop: function () {
            _enterframe.stop();
        },
        render: function () {
            this.renderer.render(this.scene, this.camera);
            this.dispatchEvent(new Event(EnterFrame.RENDER));
        }
    }, EventDispatcher.prototype);

    module.exports = Scene;
}());


/** WEBPACK FOOTER **
 ** ./holiday-map/threejs/AbstractScene.js
 **/